import React from 'react';
import { createUseStyles } from 'react-jss';
import { Sidebar } from 'Shared/Sidebar/Sidebar';
import { Heading } from 'evergreen-ui';
import useSidebar from 'Shared/Sidebar/useSidebar';
import { SettingsSidebar } from './Sidebar';

const useStyles = createUseStyles({
  settings_page: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    overflow: 'hidden',
  },
  settings_page_content: {
    display: 'grid',
    padding: '.5em',
    backgroundColor: 'white',
    overflow: 'auto',
  },
});

export const SettingsTopbarPage = React.memo(({ sidebarGroups = [], content }) => {
  const classes = useStyles();
  const { isPinned, isHide, onChangeHide, onChangePinned } = useSidebar();
  return (
    <div className={classes.settings_page}>
      <Sidebar
        isHide={isHide}
        isPinned={isPinned}
        onClickHide={onChangeHide}
        onClickPin={onChangePinned}
        title="Навигация"
        containerStyles={{ overflow: 'hidden', display: 'grid' }}
      >
        <SettingsSidebar groups={sidebarGroups} />
      </Sidebar>
      <div className={classes.settings_page_content}>
        {content}
      </div>
    </div>
  );
});
SettingsTopbarPage.displayName = 'SettingsTopbarPage';
